import React, { useState, useEffect } from 'react'
import { useStoreState } from 'easy-peasy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { tcGenerator } from '../../../services/tcGenerator';
import { useParams } from 'react-router-dom';

function PDFTerms() {

    const { productCode } = useParams();
    const [Template, setTemplate] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        getTemplate();
    }, []);

    const getTemplate = async () => {
        const PC = productCode;

        setTemplate("");
        setErrorMessage("");

        try {
            const { fileContent, hasErrors, errorMessage } = await tcGenerator(PC);
            if (hasErrors) return setErrorMessage(errorMessage);
            setTemplate(fileContent);
        } catch {
            setErrorMessage("Unknown Error");
        }
    }

    const handleDownload = async (e) => {

        e.preventDefault();

        const byteCharacters = atob(Template);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = 'Terms';
        link.click();

        URL.revokeObjectURL(url);
    }

    return (
        <div className='container'>
            <div className="terms-print">
                <button type="button" className="button-link" onClick={handleDownload} disabled={errorMessage.length > 0}>
                    <FontAwesomeIcon icon={faPrint} /> &nbsp; Download PDF
                </button>
            </div>
            <div>
                {Template ? (
                    <iframe
                        title="Terms and Conditions PDF"
                        src={`data:application/pdf;base64,${Template}`}
                        width="100%"
                        style={{ border: 'none', height: '50rem' }}
                    />
                ) : (
                    <div>{errorMessage}</div>
                )}
            </div>
        </div>
    )
}

export default PDFTerms;